// extracted by mini-css-extract-plugin
export default {"root":"ShipmentMethode_root__37Zg7","ckechbox":"ShipmentMethode_ckechbox__rM9S+","icon":"ShipmentMethode_icon__SIVje"};